import { common as esCommon } from './es/common';
import { common as enCommon } from './en/common';

export const resources = {
  es: {
    common: esCommon,
  },
  en: {
    common: enCommon,
  },
};
